(function() { window.GUID_c2a00a11_2732_4ebd_9635_a16b3cc3731c = { getGuid: function() { return "c2a00a11-2732-4ebd-9635-a16b3cc3731c"; } }; })();
var CompuSport;
(function (CompuSport) {
    var Controls;
    (function (Controls) {
        class Dashboard {
            constructor() {
                this.refreshTimeSec = 300;
                this.popupVisible = false;
                console.log("Dashboard: Initializing...");
                this.bindEvents();
            }
            bindEvents() {
                let me = this;
                if ($('#masterpage__dashboard').hasClass('tournament')) {
                    me.startAutoRefresh();
                }
                CS.body.offon('click.dashboard-tab', '.dashboard__diag-category-tab', function (e) {
                    let $tab = $(e.currentTarget);
                    let $dashboardContainer = $('#masterpage__dashboard__diag-categories-items-container');
                    let newCategory = $tab.data('category');
                    let currentCategory = $dashboardContainer.data('category');
                    $dashboardContainer.data('category', newCategory);
                    me.showPanelBasedOnCategory(newCategory);
                    if (currentCategory == newCategory && $dashboardContainer.is(':visible')) {
                        me.close();
                    }
                    else {
                        $dashboardContainer.slideDown();
                    }
                }).offon('click.dashboard-item', '.dashboard__diag-item', function (e) {
                    me.startAutoRefresh();
                    let $item = $(e.currentTarget);
                    let $button = $(e.target);
                    if ($button[0].tagName == "SPAN") {
                        $button = $button.closest('.button');
                    }
                    let data = {
                        itemsValues: me.getItemsDataToFix($item)
                    };
                    if ($item.hasClass('fixing')) {
                        return;
                    }
                    if ($button.hasClass('dashboard__diag-item-fix') && !$button.hasClass('isnotfixable')) {
                        $item.addClass('fixing');
                        let url = CSParameters.BaseUrl + "Dashboard/FixIt/" + CSParameters.SportEventId;
                        CompuSport.Ajax.Post(url, data, function (response) {
                            let $rows = $(response);
                            me.replaceOldWithNewRow($rows, me);
                        });
                    }
                    else if ($button.hasClass('dashboard__diag-item-dismiss')) {
                        let url = CSParameters.BaseUrl + "Dashboard/DismissIt/" + CSParameters.SportEventId;
                        CompuSport.Ajax.Post(url, data, function (response) {
                            let $rows = $(response);
                            me.refresh();
                            //me.replaceOldWithNewRow($rows, me);
                        });
                    }
                    else if ($button.hasClass('dashboard__diag-item-undismiss')) {
                        let url = CSParameters.BaseUrl + "Dashboard/UnDismissIt/" + CSParameters.SportEventId;
                        CompuSport.Ajax.Post(url, data, function (response) {
                            let $rows = $(response);
                            me.refresh();
                            //me.replaceOldWithNewRow($rows, me);
                        });
                    }
                    else if ($button.hasClass('dashboard__diag-item-more-info')) {
                        var popup = new CompuSport.Controls.Popup();
                        popup.OnShowing = function () {
                            me.popupVisible = true;
                        };
                        popup.OnClosing = function () {
                            me.popupVisible = false;
                        };
                        popup.GetAndShow({
                            PopupId: 'CheckIsReceived',
                            Url: CSParameters.BaseUrl + 'Dashboard/ShowMoreInfo/',
                            Data: data,
                            AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
                        });
                    }
                }).offon('click.dashboard-refresh', '#masterpage__dashboard-button-refresh', function () {
                    me.refresh();
                }).offon('click.dashboard-close', '#masterpage__dashboard-button-close', function () {
                    me.close();
                }).offon('mousedown.dashboard-outside', function (e) {
                    if (me.popupVisible) {
                        return;
                    }
                    let $target = $(e.target);
                    let $parent1 = $target.closest('.dashboard__diag-category-tab');
                    let $parent2 = $target.closest('#masterpage__dashboard__diag-categories-items-container');
                    if ($parent1.length == 0 && $parent2.length == 0) {
                        me.close();
                    }
                });
            }
            showPanelBasedOnCategory(category = null) {
                let $tabs = $('.dashboard__diag-category-tab');
                let $currentTab = $tabs.filter('.dashboard__diag-category-tab.' + category);
                let $dashboardContainer = $('#masterpage__dashboard__diag-categories-items-container');
                let oldCategory = $dashboardContainer.data('category');
                if (!category) {
                    category = oldCategory;
                }
                $tabs.removeClass('highlighted');
                $currentTab.addClass('highlighted');
                $dashboardContainer.find('.masterpage__dashboard__diag-category-items-container').hide();
                if (category == "all") {
                    $dashboardContainer.find('.masterpage__dashboard__diag-category-items-container:not(.dismissed)').show();
                }
                else {
                    $dashboardContainer.find('.masterpage__dashboard__diag-category-items-container.' + category).show();
                }
            }
            close() {
                let $dashboardContainer = $('#masterpage__dashboard__diag-categories-items-container');
                $dashboardContainer.slideUp(150, () => {
                    let $tabs = $('.dashboard__diag-category-tab');
                    $tabs.removeClass('highlighted');
                });
            }
            startAutoRefresh() {
                let me = this;
                clearInterval(me.timer);
                me.timer = window.setInterval(function () {
                    me.refresh();
                }, me.refreshTimeSec * 1000);
            }
            refresh() {
                let me = this;
                if ($('.dashboard__diag-item.fixing').length > 0) {
                    return;
                }
                let url = CSParameters.BaseUrl + "Dashboard/Refresh/" + CSParameters.SportEventId;
                CompuSport.Ajax.Post(url, null, function (response) {
                    if (response.Success == false) {
                        clearInterval(me.timer);
                    }
                    else {
                        let $new = $(response.html);
                        let $oldMasterpage__dashboard = CS.body.find('#masterpage__dashboard');
                        let $newMasterpage__dashboard = $new.filter('#masterpage__dashboard');
                        if ($oldMasterpage__dashboard && $oldMasterpage__dashboard.length && $newMasterpage__dashboard && $newMasterpage__dashboard.length) {
                            $oldMasterpage__dashboard[0].innerHTML = $newMasterpage__dashboard[0].innerHTML;
                        }
                        let $oldItemsContainer = CS.body.find('#masterpage__dashboard__diag-categories-items-container');
                        let $newItemsContainer = $new.filter('#masterpage__dashboard__diag-categories-items-container');
                        if ($oldItemsContainer && $oldItemsContainer.length > 0 && $newItemsContainer && $newItemsContainer.length > 0) {
                            $oldItemsContainer[0].innerHTML = $newItemsContainer[0].innerHTML;
                        }
                        me.showPanelBasedOnCategory();
                        me.refreshTabs();
                    }
                });
            }
            getItemsDataToFix($items) {
                let itemsValues = new Array();
                $.each($items, function (i, element) {
                    itemsValues.push(JSON.stringify($(element).data('html')));
                });
                return itemsValues;
            }
            replaceOldWithNewRow($newRow, instance) {
                let me = this;
                let $oldRow = $('#' + $newRow.attr('id'));
                $oldRow.attr('class', ($newRow.attr('class')));
                $oldRow.find('.dashboard__diag-item-fix').replaceWith($newRow.find('.dashboard__diag-item-fix'));
                $oldRow.find('.dashboard__diag-item-failed').replaceWith($newRow.find('.dashboard__diag-item-failed'));
                if ($oldRow.hasClass('fixed')) {
                    setTimeout(function () {
                        $oldRow.slideUp();
                        me.refreshTabs();
                    }, 3000);
                }
            }
            refreshTabs() {
                let me = this;
                me.refreshAlarmsCounts();
                let $tabs = $('.dashboard__diag-category-tab');
                $tabs.each(function (y, element) {
                    let keep = false;
                    let $tab = $(element);
                    let $circles = $tab.find('.dashboard__diag-category-tab-severity-level');
                    for (var i = 0; i < $circles.length; i++) {
                        let circle = $circles[i];
                        if (circle.innerHTML != "0") {
                            keep = true;
                        }
                        else {
                            $(circle).remove();
                        }
                    }
                    if (!keep) {
                        $tab.remove();
                    }
                });
                let $visibleCategories = $('.masterpage__dashboard__diag-category-items-container:visible');
                if ($visibleCategories.find('.dashboard__diag-item:not(.fixed)').length > 0) {
                    $visibleCategories.each(function (i, cat) {
                        let $category = $(cat);
                        let $rows = $category.find('.dashboard__diag-item:not(.fixed)');
                        if ($rows.length == 0) {
                            $category.slideUp();
                        }
                    });
                }
                else {
                    me.close();
                }
            }
            refreshAlarmsCounts() {
                let $countCircles = $('.dashboard__diag-category-tab-severity-level');
                $countCircles.each(function (i, element) {
                    let $circle = $(element);
                    $circle[0].innerHTML = "0";
                });
                let $rows = $('.dashboard__diag-item:not(.fixed)');
                $.each($rows, function (e, element) {
                    let $row = $(element);
                    let category = $row.data('category');
                    let level = $row.data('severitylevel');
                    let $circle = $countCircles.filter("." + level);
                    if (category != "dismissed") {
                        let $allCircle = $circle.filter('.all');
                        if ($allCircle && $allCircle.length > 0) {
                            let allCount = parseInt($allCircle[0].innerHTML);
                            if (allCount < 99) {
                                allCount += 1;
                            }
                            $allCircle[0].innerHTML = allCount.toString();
                        }
                    }
                    let $categoryCircle = $circle.filter('.' + category);
                    if ($categoryCircle && $categoryCircle.length > 0) {
                        let categoryCount = parseInt($categoryCircle[0].innerHTML);
                        if (categoryCount < 99) {
                            categoryCount += 1;
                        }
                        $categoryCircle[0].innerHTML = categoryCount.toString();
                    }
                });
            }
        }
        Controls.Dashboard = Dashboard;
        new Dashboard();
    })(Controls = CompuSport.Controls || (CompuSport.Controls = {}));
})(CompuSport || (CompuSport = {}));

//# sourceMappingURL=dashboard.js.map
